import { memo } from "react";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <div className="logo-section">
      <Link to="/">
        <img
          src="/images/pasaporte_empleo.png"
          alt="Logo Pasaporte Hacia el Empleo"
          className="logo"
          width={100}
          height={200}
          fetchPriority="high"
        />
      </Link>
      <div className="funding-text">
        <p className="hidden xl:block">
          Línea N4: proyectos piloto e innovación en Servicios Sociales
          Comunitarios.
          <br />
          Plan de Recuperación, Transformación y Resiliencia (PRTR). NEXT
          GENERATION EU
        </p>
      </div>
    </div>
  );
};

export default memo(Logo);
